import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { PatientService } from "./patient.service";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { IPatientInfo } from "./ipatient-info";

@Injectable({
    providedIn: 'root'
})
export class PatientResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(private _patientService: PatientService) {
    }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, patients: IPatientInfo[] }>> {
        var data = {
            pageNumber: 0,
            pageSize: 100,
        };
        return this._patientService.getPatients(data);
    }
}